module.exports = __webpack_public_path__ + "static/media/snoopyfreezing02.d8635738.gif";